<template>
    <div>
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="vehicleFreePlatform"
            :currentPage="searchObj.pageNo"
            @row-db-click="handleRowDbClick"
            @refresh-btn="load"
            @add-btn="handleAdd"
            @save-btn="handleSave"
            @del-btn="handleDelete"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @selectChange="selectChange"
        ></m-pane>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import mPane from '../../../../../../components/Table/Index.vue';
import config from './config.js';
import { queryLessSystem, createLessSystem, saveLessSystem, deleteLessSystem } from '../../../../../../api/lessThanCarload.js';
export default {
    name: 'LessThanCarload',
    props: {
        supplierTab: {
            type: Object,
            default: () => {}
        },
        activeCode: {
            type: String,
            default() {
                return ''
            },
        },
        code: {
            type: String,
            default() {
                return ''
            },
        },
    },
    components: { mPane },
    data() {
        return {
            config,
            checkedList: [],
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1,
            searchObj: {
                pageNo: 1,
                pageSize: 10,
                supplierCode: ''
            }
        };
    },
    computed: {
        ...mapState(['supplier'])
    },
    mounted() {
        this.searchObj.supplierCode = this.$route.query.supplierCode || this.supplier.supplierCode;
        this.load();
    },
    methods: {
        load() {
            this.loading = true;
            queryLessSystem(this.searchObj).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => { this.loading = false; });
        },
        handleDelete() {
            const ids = [];
            this.checkedList.forEach(li => { li.id && ids.push(li.id); });
            if (!ids.length) {
                return this.$message.warning('请选择已有的数据');
            }
            deleteLessSystem(ids).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功!');
                    this.load();
                }
            }).finally(() => { this.loading = false; });
        },
        selectChange(data) {
            this.checkedList = data;
        },
        pageChange(data) {
            this.$emit('sensitive')
            this.searchObj.pageNo = data;
            this.load();
        },
        sizeChange(data) {
            this.$emit('sensitive')
            this.searchObj.pageNo = 1;
            this.searchObj.pageSize = data;
            this.load();
        },
        handleAdd() {
            this.$refs.tablePage.$refs.table.addRow();
        },
        handleSave() {
            if (this.checkedList.length !== 1) {
                return this.$message.warning('请选择一条数据');
            }
            if (!this.$refs.tablePage.$refs.table.$refs.mNewTable.saveData()) {
                return false;
            }
            let apiFunc = createLessSystem;
            let msg = '新增成功!';
            const { id, exchangePlatform, accountName, professionalAccount, professionalKey, enableFlag, version } = this.checkedList[0];
            let params = { exchangePlatform, accountName, professionalAccount, professionalKey, enableFlag, supplierCode: this.searchObj.supplierCode };
            if (id) {
                apiFunc = saveLessSystem;
                msg = '编辑成功!';
                params = { ...params, id, version };
            }
            this.loading = true;
            apiFunc(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(msg);
                    this.load();
                }
            }).finally(() => { this.loading = false; });
        },
        handleRowDbClick(row) { }
        // formatData(data) {
        //     return data.map(item => {
        //         item.whType = this.dict.SYS_SU_WH_TYPE[item.whType];
        //         item.leasingType = this.dict.SU_LEASE_TYPE[item.leasingType];
        //         item.buildingType = this.dict.SYS_SU_BUILDING_TYPE[item.buildingType];
        //         item.parkPath = this.dict.SYS_SU_PARK_PATH[item.parkPath];
        //         item.securitySystemFlag = this.dict.SYS_SUPPLIER_HAS_NO[item.securitySystemFlag];
        //         item.fireInspection = this.dict.SYS_SU_FIRE_INSPECTION[item.fireInspection];
        //         item.fireFacilities = this.dict.SYS_SU_FIRE_FACILITIES[item.fireFacilities];
        //         item.platform = this.dict.SYS_SU_PLATFORM[item.platform];
        //         item.canopy = this.dict.SYS_SU_CANOPY[item.canopy];
        //         item.officeFlag = this.dict.SRM_WH_OFFICE[item.officeFlag];
        //         item.dormFlag = this.dict.SRM_WH_DORM[item.dormFlag];
        //         item.poweredSystemFlag = this.dict.SRM_WH_POWER_SYSTEM[item.poweredSystemFlag];
        //         item.whStatus = this.dict.SRM_SU_WH_STATUS[item.whStatus];
        //         item.physicsWarehouseStatus = this.dict.SRM_WH_STATUS[item.physicsWarehouseStatus];
        //         return item;
        //     });
        // }
    },
    watch: {
        activeCode(val) {
            if (val === this.code) {
                this.load()
            }
        },
    },
};
</script>
<style lang="less">
</style>